import { render, staticRenderFns } from "./DonutChartcon.vue?vue&type=template&id=36cd5224&scoped=true&"
import script from "./DonutChartcon.vue?vue&type=script&lang=js&"
export * from "./DonutChartcon.vue?vue&type=script&lang=js&"
import style0 from "./DonutChartcon.vue?vue&type=style&index=0&id=36cd5224&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36cd5224",
  null
  
)

export default component.exports